
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import enTranslation from './public/locales/en/translation.json';

i18n
  .use(initReactI18next)
  .use(HttpApi)
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
    },
    lng: 'en',
    fallbackLng: 'en',
    supportedLngs: ['en', 'ar', 'bn', 'de', 'es', 'fr', 'hi', 'id', 'it', 'ja', 'ko', 'pt', 'ru', 'ur', 'zh', 'zh-TW'],
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    // Only use the backend for non-English languages
    partialBundledLanguages: true,
  });

export default i18n;

